// export DsfVirtualTree from './virtualTree.vue'

// export const DsfVirtualTree =Vue.defineLazyComponent(()=>require('./virtualTree.vue'))
export const DsfVirtualTree = dsf.defineAsyncComponent("DsfVirtualTree", () => import(/* webpackChunkName: "platform_pc_tree_module" */ "./virtualTree.vue"));